import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios_api } from "../../api";
import { getSearchQuery, IQueryParams } from "../../common";
import { IWaitList } from "./waitlistTypes";
import { createAsyncThunkPostWrapper } from "../store.wrapper";





const GET_WAITLIST_BASE_URL = "waitlist/get-waitlist"
const UPSERT_WAITLIST_BASE_URL = "waitlist/upsert-waitlist"

export const fetchWaitListAsync = createAsyncThunk<{ recordCount: number, data: IWaitList[] }, { queryParams: IQueryParams, is_waiting_done: string }>(
    'reservations/fetchWaitlistAsync', async ({ queryParams, is_waiting_done }, thunkAPI) => {
        const searchQuery = getSearchQuery(queryParams);
        let waitingUrl = `${GET_WAITLIST_BASE_URL}${searchQuery}`
        if (is_waiting_done !== "-1") {
            waitingUrl += `&is_waiting_done=${is_waiting_done}`
        }
        const response = await axios_api.get(waitingUrl)
        const data: IWaitList[] = response.data.data;
        const count = response.data.totalRecords
        return { recordCount: count, data: data } //.filter((res) => res.status !== "CANCELED")
    },
)



export const upsertWaitListAsync = createAsyncThunkPostWrapper<IWaitList, IWaitList>(
    'reservations/upsertWaitListAsync', async (payload: IWaitList, thunkAPI) => {
        const { waitlist_id, customer_fact_uuid, current_waiting_count, average_waiting_time, created_by_uuid, modified_by_uuid, create_ts, insert_ts, waiting_from, ...rest } = payload
        const response = await axios_api.post(UPSERT_WAITLIST_BASE_URL, rest)
        return response.data
    },
)
export const updateWaitlistStatusAsync = createAsyncThunk(
    'reservations/updateWaitlistStatusAsync',
    async ({ waitlist_uuid, status, outlet_uuid, outlet_name }: { waitlist_uuid: string; status: string; outlet_uuid: string; outlet_name: string }) => {
        const response = await axios_api.post(`waitlist/upsert-waitlist`, { waitlist_uuid, status, outlet_uuid, outlet_name });
        return response.data;
    }
);